// Shared with the standard upload flow; keep POV naming consistent across sources.
export const REVIEW_POV_OPTIONS = [
  "Coach's POV", "Astra", "Breach", "Brimstone", "Chamber", "Clove", "Cypher",
  "Deadlock", "Fade", "Gekko", "Harbor", "Iso", "Jett", "KAY/O", "Killjoy",
  "Neon", "Omen", "Phoenix", "Raze", "Reyna", "Sage", "Skye", "Sova", "Tejo",
  "Viper", "Yoru",
];
